<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { GetLastMonth, GetToday } from '../../method/Date'
import { GetImgs, GetSImgs, SqlManipulate } from '../../method/Post';
import { NumberCut } from '../../method/floatCalculate';
import ls from '../../method/localStorage';
import { ElMessageBox, ElTable } from 'element-plus';
import InqueryDetail from './InqueryDetail.vue';
const prop = defineProps<{
    langPack: Map<string, string>,
    lang: string,
    orientation: string
}>();
let searchName = ref("");
let searchName2 = ref("");
let searchName3 = ref([GetLastMonth(), GetToday()]);
let startDate = ref(GetLastMonth())
let endDate = ref(GetToday())
let data = ref(new Array<any>())
const multipleTableRef = ref<InstanceType<typeof ElTable>>()
const multipleSelection = ref<Array<any>>([])
let total = ref(0);
let pageSize = ref(24);
let currentPage = ref(1);
let previewList = ref(new Array<string>())
let emit = defineEmits(["AddTab"])
let showMode = ref("table")
let isUpdateMultipleSelection = ref(false);
let loading = ref(false)
const selectedOid = ref(0);
const AddCard = ref(false)
const drawer = ref(false)
// 竖屏模式下内容区域的引用
const verticalContentRef = ref<HTMLElement>();

const handleScroll = () => {
    if (!verticalContentRef.value) return;

    const { scrollTop, scrollHeight, clientHeight } = verticalContentRef.value;

    // 当滚动到距离底部20px时触发loadmore
    if (scrollHeight - scrollTop - clientHeight < 20) {
        // 确保还有更多数据可以加载
        if (data.value.length < total.value && !loading.value) {
            loadmore();
        } else {
            console.log("没有更多数据或正在加载中");
        }
    }
}

onMounted(() => {
    // 检查是否为移动设备
    handleSearch();
    // 监听竖屏模式下的滚动事件
    if (prop.orientation == 'vertical') {
        verticalContentRef.value?.addEventListener('scroll', handleScroll);
    }
});

watch(() => prop.orientation, (newVal) => {
    if (newVal == 'vertical') {
        verticalContentRef.value?.addEventListener('scroll', handleScroll);
    } else {
        verticalContentRef.value?.removeEventListener('scroll', handleScroll);
    }
})

onBeforeUnmount(() => {
    // 移除滚动事件监听
    if (prop.orientation == 'vertical') {
        verticalContentRef.value?.removeEventListener('scroll', handleScroll);
    }
})


const handleClickSearch = () => {
    currentPage.value = 1;
    multipleSelection.value = [];
    handleSearch();
}
const handleReset = () => {
    searchName.value = "";
    searchName2.value = "";
    searchName3.value = [GetLastMonth(), GetToday()];
    multipleSelection.value = [];
    handleSearch();
}


const handleSearch = () => {
    loading.value = true
    SqlManipulate("Web_Search", { JSON: JSON.stringify({ Pre: searchName.value, ItemName: searchName2.value, Date: searchName3.value, pageSize: pageSize.value, pageIndex: currentPage.value, TCustId: ls.get("CustId") }) }, (res: any) => {
        isUpdateMultipleSelection.value = true
        data.value = res[0]
        total.value = Number.parseInt(res[1][0].CountRows);
        GetSImgs(data.value)
        GetImgs(data.value)
        setTimeout(() => {
            toggleSelection(data.value)
            isUpdateMultipleSelection.value = false
            loading.value = false
        }, 500);
    })
}

const handleSizeChange = (val: number) => {
    console.log(`${val} items per page`)
    currentPage.value = 1;
    handleSearch();
}
const handleCurrentChange = (val: number) => {
    console.log(`current page: ${val}`)
    handleSearch();
}
const loadmore = () => {
    if (loading.value) {
        return
    }
    loading.value = true
    currentPage.value++;
    SqlManipulate("Web_Search", { JSON: JSON.stringify({ Pre: searchName.value, ItemName: searchName2.value, Date: searchName3.value, pageSize: pageSize.value, pageIndex: currentPage.value, TCustId: ls.get("CustId") }) }, (res: any) => {
        let newdata = res[0]
        total.value = Number.parseInt(res[1][0].CountRows);
        GetSImgs(newdata)
        GetImgs(newdata)
        data.value = [...data.value, ...newdata]
        setTimeout(() => {
            loading.value = false
        }, 500);
    })
}

const handleItemDetail = (Oid: number) => {
    AddCard.value=true
    if (prop.orientation == 'vertical') {
        selectedOid.value = Oid
        drawer.value = true
    } else {
        emit("AddTab", { title: "InqueryDetail", content: "InqueryDetail", multi: true, Oid: Oid })
    }
    setTimeout(() => {
        AddCard.value=false
    }, 500);
}

const handlePicClick = (URL: string) => {
    previewList.value = [];
    previewList.value.push(URL)
}
const handleSelectionChange = (val: Array<any>) => {
    if (!isUpdateMultipleSelection.value) {
        let index = multipleSelection.value.findIndex(m => m.pageId == currentPage.value);
        if (index > -1) {
            multipleSelection.value[index].data = val
        } else {
            multipleSelection.value.push({ pageId: currentPage.value, data: val })
        }
    }
}
const toggleSelection = (rows: Array<any>) => {
    if (rows) {
        let index = multipleSelection.value.findIndex(m => m.pageId == currentPage.value)
        if (index > -1) {
            rows.forEach((row) => {
                // TODO: improvement typing when refactor table
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                if (multipleSelection.value[index].data.findIndex((m: any) => m.Oid == row.Oid) > -1) {
                    multipleTableRef.value!.toggleRowSelection(row, true)
                }
            })
        }
    } else {
        console.log("清除")
        multipleTableRef.value!.clearSelection()
    }
}

const handleSelect = (item: any) => {
    if(AddCard.value){
        return
    }
    let index = multipleSelection.value.findIndex(m => m.pageId == currentPage.value);
    if (index > -1) {
        let itemIndex = multipleSelection.value[index].data.findIndex((m: any) => m.Oid == item.Oid);
        if (itemIndex > -1) {
            multipleSelection.value[index].data.splice(itemIndex, 1);
        } else {
            multipleSelection.value[index].data.push(item)
        }
    } else {
        multipleSelection.value.push({ pageId: currentPage.value, data: [item] })
    }
}
const handleModeChange = () => {
    if (showMode.value == 'card') {
        isUpdateMultipleSelection.value = true;
    } else {

        toggleSelection(data.value)
        isUpdateMultipleSelection.value = false;
    }
}

const handleAddIntoCart = () => {
    let data = new Array<number>;
    multipleSelection.value.forEach(ele => {
        ele.data.forEach((m: any) => {
            data.push(m.Oid);
        })
    })
    SqlManipulate("Web_ListAddToCart", { TCustId: ls.get("CustId"), Oid: JSON.stringify(data) }, (res: any) => {
        console.log(res)
        if (res.flag == 0) {
            ElMessageBox.alert(ref(prop.langPack).value.get("SubmitSuccess"), ref(prop.langPack).value.get("Success"), {
                confirmButtonText: ref(prop.langPack).value.get("confirm")
            })
        } else {
            ElMessageBox.alert(res.msg, ref(prop.langPack).value.get("Error"), {
                confirmButtonText: ref(prop.langPack).value.get("confirm")
            })
        }
    })
}

const handleVerticalDateChange = () => {
    searchName3.value = [startDate.value, endDate.value]
    handleSearch();
}

const handleVerticalInput = () => {
    handleSearch()
}
</script>
<template>
    <div v-if="orientation == 'horizontal'">
        <el-card class="card">
            <el-row>
                <el-col :span="18">
                    <div class="carditem">
                        <el-text class="cardtext">{{ langPack.get("maitou") }}</el-text>
                        <el-input v-model="searchName" class="cardinput" style="width: 6rem;"></el-input>
                        <el-text class="cardtext">{{ langPack.get("productName") }}</el-text>
                        <el-input v-model="searchName2" class="cardinput" style="width: 10rem;"></el-input>
                        <el-text class="cardtext">{{ langPack.get("date") }}</el-text>
                        <div style="width: 16rem;margin-left: 0.5rem;">
                            <el-date-picker v-model="searchName3" type="daterange" unlink-panels range-separator="-"
                                class="cardinput" :start-placeholder="langPack.get('startDate')"
                                :end-placeholder="langPack.get('endDate')" value-format="YYYY-MM-DD" />
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="carditem" style="margin-left: 1rem;">
                        <el-button type="primary" @click="handleClickSearch">{{ langPack.get("Search") }}</el-button>
                        <el-button @click="handleReset">{{ langPack.get("Reset") }}</el-button>
                        <el-radio-group v-model="showMode" size="small" style="margin-left: 1rem;"
                            @change="handleModeChange">
                            <el-radio-button label="card" value="card">
                                <el-icon>
                                    <PictureFilled />
                                </el-icon>
                            </el-radio-button>
                            <el-radio-button label="table" value="table">
                                <el-icon>
                                    <List />
                                </el-icon>
                            </el-radio-button>
                        </el-radio-group>
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <div class="mainpart">
            <el-table ref="multipleTableRef" v-loading="loading" :data="data" style="width: 100%;" stripe
                v-if="showMode == 'table'" max-height="62vh" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" />
                <el-table-column prop="Date" :label="langPack.get('date')" width="140" />
                <el-table-column :label="langPack.get('ProductIMG')" width="200">
                    <template #default="scope">
                        <div @click="handlePicClick(scope.row.IMG_1)">
                            <el-image style="width:4rem;height:4rem;margin: 0;" :src="scope.row.IMG_1_S" fit="contain"
                                :preview-teleported="true" :preview-src-list="previewList" hide-on-click-modal>
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="Pre" :label="langPack.get('maitou')" width="120" />
                <el-table-column prop="Char_2" :label="langPack.get('huohao')" width="140" />
                <el-table-column prop="Item_CN" :label="langPack.get('ProductName')" width="180" v-if="lang == '简体中文'">
                    <template #default="scope">
                        <div @click="handleItemDetail(scope.row.Oid)">
                            <text style="color: #409EFF;border-bottom: 1px solid #409EFF;">{{ scope.row.Item_CN
                            }}</text>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="Item_EN" :label="langPack.get('ProductName')" width="180"
                    v-if="lang == 'English'">
                    <template #default="scope">
                        <div @click="handleItemDetail(scope.row.Oid)">
                            <text style="color: #409EFF;border-bottom: 1px solid #409EFF;">{{ scope.row.Item_EN
                            }}</text>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="Item_ES" :label="langPack.get('ProductName')" width="180"
                    v-if="lang == 'Español'">
                    <template #default="scope">
                        <div @click="handleItemDetail(scope.row.Oid)">
                            <text style="color: #409EFF;border-bottom: 1px solid #409EFF;">{{ scope.row.Item_ES
                            }}</text>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="PWeight" :label="langPack.get('PWeight')" width="120" />
                <el-table-column prop="Volume" :label="langPack.get('Volume')" width="120" />
                <el-table-column prop="AuxTaxPrice_Weight" :label="langPack.get('Price')" width="120">
                    <template #default="scope">
                        {{ NumberCut(scope.row.AuxTaxPrice_QtyPiece) }}
                    </template>
                </el-table-column>
                <el-table-column prop="Char_MS_CN" :label="langPack.get('ProductDesc')" v-if="lang == '简体中文'"
                    over-flow-tooltip />
                <el-table-column prop="Char_MS_EN" :label="langPack.get('ProductDesc')" v-if="lang == 'English'"
                    over-flow-tooltip />
                <el-table-column prop="Char_MS_ES" :label="langPack.get('ProductDesc')" v-if="lang == 'Español'"
                    over-flow-tooltip />
                <el-table-column prop="Char_MS_ES" :label="langPack.get('ProductDesc')" v-if="lang == 'Português'"
                    over-flow-tooltip />
            </el-table>
            <el-row v-if="showMode == 'card'">
                <el-col v-for="item in data" :span="4">
                    <div class="itemcard" @click="handleSelect(item)"
                        :style="{ backgroundColor: multipleSelection.findIndex(m => m.pageId == currentPage && m.data.findIndex((n: any) => n.Oid == item.Oid) > -1) > -1 ? '#ff6622' : '#fff' }">
                        <el-image class="itemImg" :src="item.IMG_1_S" fit="cover" />
                        <div class="itemName">
                            <text v-if="lang == '简体中文'">{{ item.Item_CN }}</text>
                            <text v-if="lang == 'English'">{{ item.Item_EN }}</text>
                            <text v-if="lang == 'Español'">{{ item.Item_ES }}</text>
                            <text v-if="lang == 'Português'">{{ item.Item_ES }}</text>
                        </div>
                        <div class="itemPrice">
                            <text style="color:#409EFF">${{ item.AuxTaxPrice_QtyPiece }}</text>
                            <el-button type="primary" plain @click="handleItemDetail(item.Oid)">{{ langPack.get("Buy")
                            }}</el-button>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="pagenation">
            <el-button style="position: absolute;left: 1rem;" @click="handleAddIntoCart" type="success">{{
                langPack.get("AddToCart") }}</el-button>
            <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                layout="total,sizes,prev, pager, next" :total="total" background :page-sizes="[12, 24, 48, 96]"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
    </div>

    <!-- 将v-if移到外层，确保ref始终可以获取到元素 -->
    <div v-if="orientation == 'vertical'">
        <div class="card-vertical">
            <div style="display: flex;flex-direction: row;width: 100%;justify-content: space-between;">
                <div class="carditem-vertical">
                    <el-text class="cardtext">{{ langPack.get("maitou") }}</el-text>
                    <el-input v-model="searchName" class="cardinput-vertical" @blur="handleVerticalInput"></el-input>
                </div>
                <div class="carditem-vertical">
                    <el-text class="cardtext">{{ langPack.get("productName") }}</el-text>
                    <el-input v-model="searchName2" class="cardinput-vertical" @blur="handleVerticalInput"></el-input>
                </div>
            </div>
            <div style="display: flex;flex-direction: row;width: 100%;justify-content: space-between;">
                <el-date-picker v-model="startDate" class="cardinput-vertical" unlink-panels type="date"
                    value-format="YYYY-MM-DD" :placeholder="langPack.get('startDate')"
                    @change="handleVerticalDateChange">
                </el-date-picker>
                <el-date-picker v-model="endDate" class="cardinput-vertical" unlink-panels type="date"
                    value-format="YYYY-MM-DD" :placeholder="langPack.get('endDate')" @change="handleVerticalDateChange">
                </el-date-picker>
            </div>
        </div>
        <div class="mainpart-vertical" ref="verticalContentRef">
            <el-row>
                <el-col v-for="item in data" :span="12">
                    <div class="itemcard-vertical" @click="handleSelect(item)"
                        :style="{ backgroundColor: multipleSelection.findIndex(m => m.pageId <= currentPage && m.data.findIndex((n: any) => n.Oid == item.Oid) > -1) > -1 ? '#ff6622' : '#fff' }">
                        <el-image class="itemImg-vertical" :src="item.IMG_1_S" fit="cover" />
                        <div class="itemName">
                            <text v-if="lang == '简体中文'">{{ item.Item_CN }}</text>
                            <text v-if="lang == 'English'">{{ item.Item_EN }}</text>
                            <text v-if="lang == 'Español'">{{ item.Item_ES }}</text>
                            <text v-if="lang == 'Português'">{{ item.Item_ES }}</text>
                        </div>
                        <div class="itemPrice">
                            <text style="color:#409EFF">${{ item.AuxTaxPrice_QtyPiece }}</text>
                            <el-button type="primary" plain @click="handleItemDetail(item.Oid)">{{
                                langPack.get("Buy")
                                }}</el-button>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <text v-if="data.length >= total">没有更多数据</text>
        </div>
        <div class="pagenation-vertical">
            <el-button style="position: absolute;right: 10px;top: 5px;" @click="handleAddIntoCart" type="success">{{
                langPack.get("AddToCart") }}</el-button>
        </div>
    </div>

    <el-drawer v-model="drawer" v-if="orientation == 'vertical'" size="80%" direction="btt"
        style="border-radius: 15px 15px 0 0;padding: 0;">
        <InqueryDetail :langPack="langPack" :id="selectedOid" :lang="lang" :orientation="orientation">
        </InqueryDetail>
    </el-drawer>

</template>
<style scoped>
.card {
    margin-left: 0.8rem;
    margin-right: 0.8rem;
    height: fit-content;
    padding: 0;
}

.card-vertical {
    margin: 0;
    padding: 0;
    height: 80px;
    background-color: #fff;
}


.carditem {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}

.carditem-vertical {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 50%;
    margin: 5px;
}

.cardtext {
    width: fit-content;
}

.cardinput {
    margin-left: 0.5rem;
    width: 10rem;
    margin-right: 1rem;
}

.cardinput-vertical {
    margin-left: 0.5rem;
    width: 36rem;
    margin-right: 1rem;
}

.mainpart {
    margin: 0.2rem 0.8rem 0 0.8rem;
    border: 1px solid silver;
    border-radius: 0.2rem;
    height: 62vh;
    overflow-y: scroll;
}

.mainpart-vertical {
    margin: 0;
    padding: 0 5px 0 5px;
    height: calc(var(--vh, 1vh) * 100 - 240px);
    overflow-y: scroll;
}

.pagenation {
    display: flex;
    flex-direction: row;
    justify-content: end;
    padding-right: 1.5rem;
    margin-top: 1rem;
}

.pagenation-vertical {
    border-top: 1px solid silver;
    height: 40px;
    position: relative;
}

.itemcard {
    margin: 0.3rem;
    padding: 0;
    border-radius: 0.5rem;
    border: 1px solid silver;
}

.itemcard-vertical {
    margin: 5px 5px 5px 5px;
    padding: 0;
    border-radius: 5px;
    font-size: 16px;
}

.itemImg {
    width: 100%;
    height: 10rem;
    border-radius: 0.5rem 0.5rem 0 0;
}

.itemImg-vertical {
    width: 100%;
    height: 42rem;
    border-radius: 5px 5px 0 0;
    border-bottom: 1px solid silver;
}

.itemName {
    margin: 0.2rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 40px;
    line-height: 20px;
    text-align: left;
}

.itemPrice {
    margin-left: 0.2rem;
    margin-right: 0.7rem;
    margin-bottom: 0.5rem;
    display: flex;
    flex-direction: row;
    width: calc(100% - 0.9rem);
    justify-content: space-between;
    align-items: center;
}
</style>